/** Normalize number-input values at the input boundary before they enter form state. */
export const toNumberOrDefault = (value: number | string, fallback: number): number =>
  value === '' ? fallback : Number(value);
